export * from '../src/views/w3m-wallet-receive-view/index.js';
//# sourceMappingURL=receive.js.map